import { Link, useSubmit, useNavigation, useNavigate } from "react-router-dom";
import { Form } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import classes from './MedicineItem.module.css';
import { FaCapsules, FaIdCard, FaBuilding, FaMoneyBillWave, FaVirus, FaCalendarAlt, FaBarcode, FaEdit, FaTrash, FaArrowLeft } from 'react-icons/fa';
import ConfirmModal from "../../UI/ConfirmModal";
import { useState } from "react";

function MedicineItem({ medicineInfo }) {
  const submit = useSubmit();
  const navigation = useNavigation();
  const navigate = useNavigate();
  const isSubmitting = navigation.state === 'submitting';
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  function startDeleteHandler() {
    setShowDeleteConfirm(true);
  }

  function confirmDeleteHandler() {
    submit({ tenantOrClientId: medicineInfo.authCtx.tenantOrClientId }, { method: "delete" });
    setShowDeleteConfirm(false);
  }

  return (
    <article className={classes.patient}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        <h3 className='textHead' style={{ color: 'var(--primary-color)', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>
          <FaCapsules className="me-2" /> Medicine: {medicineInfo ? medicineInfo?.name : ''}
        </h3>
        <div className={classes.cardview}>
          <Form method="post" className={classes.form}>

            <div className={classes.sectionHeader}>
              <FaIdCard /> Medicine Information
            </div>

            <div className="row">
              <div className="col-md-4 col-6">
                <label className={classes.label} htmlFor="medicineId">Medicine ID</label>
                <input id="medicineId" type="text" name="medicineId" required defaultValue={medicineInfo ? medicineInfo?.medicineId : ''} disabled />
              </div>
              <div className="col-md-4 col-6">
                <label className={classes.label} htmlFor="name">Medicine Name</label>
                <input id="name" type="text" name="name" required defaultValue={medicineInfo ? medicineInfo?.name : ''} disabled />
              </div>
              <div className="col-md-4 col-6">
                <label className={classes.label} htmlFor="medType">Medicine Type</label>
                <select
                  id="medType"
                  name="medType"
                  defaultValue={medicineInfo ? medicineInfo?.medType : ''}
                  disabled
                >
                  <option value="" hidden>Select</option>
                  <option value="TAB">TAB</option>
                  <option value="CAP">CAP</option>
                  <option value="SYR">SYR</option>
                  <option value="SUSP">SUSP</option>
                  <option value="SAC">SAC</option>
                  <option value="INJ">INJ</option>
                  <option value="DROP">DROP</option>
                  <option value="EDRP">EDRP</option>
                  <option value="LIQ">LIQ</option>
                  <option value="OINT">OINT</option>
                  <option value="CRE">CRE</option>
                  <option value="GEL">GEL</option>
                  <option value="LOT">LOT</option>
                  <option value="SPRAY">SPRAY</option>
                  <option value="SUPP">SUPP</option>
                  <option value="ROTACAP">ROTACAP</option>
                </select>
              </div>
            </div>

            <div className={classes.sectionHeader}>
              <FaBuilding /> Manufacturing & Pricing
            </div>
            <div className="row">
              <div className="col-md-4 col-6">
                <label className={classes.label} htmlFor="manufacturer">Manufacturer</label>
                <input id="manufacturer" type="text" name="manufacturer" defaultValue={medicineInfo ? medicineInfo?.manufacturer : ''} disabled />
              </div>
              <div className="col-md-4 col-6">
                <label className={classes.label} htmlFor="price">Price</label>
                <input id="price" type="text" name="price" defaultValue={medicineInfo ? medicineInfo?.price : ''} disabled />
              </div>
              <div className="col-md-4 col-6">
                <label className={classes.label} htmlFor="disease">Disease</label>
                <input id="disease" type="text" name="disease" defaultValue={medicineInfo ? medicineInfo?.disease : ''} disabled />
              </div>
            </div>

            <div className={classes.sectionHeader}>
              <FaBarcode /> Inventory Details
            </div>
            <div className="row">
              <div className="col-md-4 col-6">
                <label className={classes.label} htmlFor="expiryDate">Expiry Date</label>
                <input id="expiryDate" type="date" name="expiryDate" defaultValue={medicineInfo?.expiryDate} disabled />
              </div>
              <div className="col-md-4 col-6">
                <label className={classes.label} htmlFor="barcode">Barcode</label>
                <input id="barcode" type="number" name="barcode" defaultValue={medicineInfo ? medicineInfo?.barcode : ''} disabled />
              </div>
            </div>

            <div className={classes.actions}>
              <Link className={classes.editBtn} to="edit">
                <FaEdit className="me-2" /> Edit Medicine
              </Link>
              <button
                type="button"
                className={classes.deleteBtn}
                onClick={startDeleteHandler}
                disabled={isSubmitting}
              >
                <FaTrash className="me-2" /> {isSubmitting ? "Deleting..." : 'Delete'}
              </button>
              <Link className={classes.backBtn} to="..">
                <FaArrowLeft className="me-2" /> Back to List
              </Link>
            </div>
          </Form>
        </div>
      </div>
      <ConfirmModal
        show={showDeleteConfirm}
        onHide={() => setShowDeleteConfirm(false)}
        onConfirm={confirmDeleteHandler}
        title="Delete Medicine"
        message="Are you sure you want to delete this medicine? This action cannot be undone."
        variant="danger"
        isLoading={isSubmitting}
      />
    </article >
  );
}

export default MedicineItem;
